export function authHeader() {
    // return authorization header with jwt token
    let AdminUser = JSON.parse(localStorage.getItem('admin-user'));

    if (AdminUser && AdminUser.token) {
        return { 'Authorization': 'Bearer ' + AdminUser.token , 'Content-Type': 'application/json' };
    } else {
        return {};
    }
}


// WEBPACK FOOTER //
// ./src/helper/authHeader.jsx